<template>
  <div class="service">
    <div class="title">{{$t('meg.Services')}}</div>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Platform Services</p>
    <h1 style="margin-top: 1.0875rem; text-align: left;margin-left: 2rem;  font-size: .6rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;">开放的视野｜优质的服务</h1>
    <div class="serviceMain">
        <div class="leftMain"></div>
        <div class="rightMain">
            <h1 class="rightTitle">{{$t('meg.Efficient')}}</h1>
            <p class="rightmain">{{$t('meg.small')}}</p>
            <hr style="width: 4.4625rem;height: 0rem;opacity: 1;border: .0125rem solid #DDD;margin-top: .2125rem;">
            <h1 class="rightTitle" style="margin-top: .875rem;">{{$t('meg.ratio')}}</h1>
            <p class="rightmain">{{$t('meg.cost')}}</p>
            <hr style="width: 4.4625rem;height: 0px;opacity: 1;border: .0125rem solid #DDD;margin-top: .2125rem;">
            <h1 class="rightTitle" style="margin-top: .875rem;">{{$t('meg.monitoring')}}</h1>
            <p class="rightmain">{{$t('meg.visualization')}}</p>
            <hr style="width: 4.4625rem;height: 0rem;opacity: 1;border: .0125rem solid #DDD;margin-top: .2125rem;">
        </div>
    </div>
  </div>
</template>

<script>
</script>

<style scoped>
.service {
    margin-top: 1.6125rem;
}
.title {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: .8625rem;
}
.serviceMain {
    margin: .5875rem 2rem;
    display: flex;
}
.leftMain {
    width: 13.4rem;
    height: 6.375rem;
    background: url("../../../assets/newImg/service.png") no-repeat;
    background-size: 100% 100%;
}
.rightMain {
    margin-left: .75rem;
    text-align: left;
}
.rightTitle {
    font-size: .4rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 800;
    color: #002FA7;
}
.rightmain {
    font-size: .225rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #818AA0;
    margin-top: .2625rem;
}
</style>
